export const redirectToEntraId = (url: string): void => {
  window.location.assign(url);
};
